import Layout from "@/components/feature/Layout";
import JsonLd from "@/components/feature/JsonLd";
import FaqAccordion from "@/components/feature/FaqAccordion";
import usePageMeta from "@/hooks/usePageMeta";
import { faqs, siteInfo } from "@/mocks/archive";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import FeaturedArchives from "./components/FeaturedArchives";
import MethodSection from "./components/MethodSection";
import TestimonialSection from "./components/TestimonialSection";
import CtaBand from "./components/CtaBand";

export default function Home() {
  usePageMeta({
    title: "溯影档案｜黑料网红考古 · 网络人物旧言论与前科回溯观察",
    description:
      "溯影档案专注黑料网红的黑历史考古：把早期发言、旧照旧言论与前科记录按时间线对照整理，附原帖存档线索与核实方法，是理性看待黑料网红旧言论的观察站。",
    keywords: "黑料网红,黑料网红黑历史,黑料网红考古,黑料网红旧言论,黑料网红前科",
    canonical: "https://scadaforweb.cn/",
  });

  return (
    <Layout>
      <JsonLd
        id="ld-website"
        data={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: siteInfo.brand,
          url: "https://scadaforweb.cn/",
          description:
            "以档案方式整理网络人物公开言行的观察站，聚焦黑料网红早期发言、旧照旧言论与前科记录的回溯。",
          inLanguage: "zh-CN",
          potentialAction: {
            "@type": "SearchAction",
            target: "https://scadaforweb.cn/archive?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
          publisher: {
            "@type": "Organization",
            name: siteInfo.brand,
            email: siteInfo.email,
          },
        }}
      />
      <JsonLd
        id="ld-faq-home"
        data={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs.map((item) => ({
            "@type": "Question",
            name: item.q,
            acceptedAnswer: { "@type": "Answer", text: item.a },
          })),
        }}
      />

      <Hero />
      <CategoryGrid />
      <FeaturedArchives />

      <MethodSection />

      <section className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="max-w-3xl mb-8 md:mb-10">
          <span className="text-xs tracking-[0.22em] text-primary-600">FAQ</span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            围观前常见的几个问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            关于来源、隐私边界和修订机制，答案都写在这里。还有疑问，欢迎从联系页告诉我们。
          </p>
        </div>
        <FaqAccordion items={faqs} />
      </section>

      <TestimonialSection />
      <CtaBand />
    </Layout>
  );
}